import React from "react";
import "../App.css";

const Treatments: React.FC = () => {
  return <div className="Treatments"> Treatments</div>;
};

export default Treatments;
